import React from "react";
import { retouching } from "./RetouchingData";
import { Link } from "react-router-dom";
import CompareSlider from "../../home/CompareSlider";
import before2 from "../../../images/services/retouch/Befor 2.webp";
import after2 from "../../../images/services/retouch/After 2.webp";
import before3 from "../../../images/services/retouch/Befor 3.webp";
import after3 from "../../../images/services/retouch/After 3.webp";
import before5 from "../../../images/services/retouch/Befor 5.webp";
import after5 from "../../../images/services/retouch/After 5.webp";
import before8 from "../../../images/services/retouch/Befor 8.webp";
import after8 from "../../../images/services/retouch/After 8.webp";

const LandingPage = () => {
  const imagePairs = [
    {
      // People Retouch
      firstImage: before2,
      secondImage: after2,
    },
    {
      // Newborn Retouching
      firstImage: before8,
      secondImage: after8,
    },
    {
      // Event Photo Retouching
      firstImage: before3,
      secondImage: after3,
    },
    {
      // School Retouching
      firstImage: before5,
      secondImage: after5,
    },
  ];
  const maxItems = Math.min(retouching.length, imagePairs.length);
  return (
    <>
      <div
        className="bg_maincolor d-flex align-items-center justify-content-center"
        style={{ height: "14rem" }}
      >
        <h1 className="display-6 prata-regular fw-bold text-center text-light ">
          Retouching Services
        </h1>
      </div>

      <div className="mx-5 ">
        {Array.from({ length: maxItems }).map((_, index) => (
          <div
            key={index}
            className={`row my-5 py-5 align-items-center ${
              index % 2 !== 0 ? "flex-row-reverse " : ""
            }`}
          >
            <div className={`col-md-6 ${index % 2 !== 0 ? "ps-5 " : ""}`}>
              <h2 className="prata-regular mb-4">{retouching[index].title}</h2>
              <p>
                {retouching[index].para1
                  .split(/(https:\/\/captureedits\.com\/)/g)
                  .map((part, i) =>
                    part === "https://captureedits.com/" ? (
                      <a
                        key={i}
                        href={part}
                        className="text_maincolor fw-bold text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        captureedits.com
                      </a>
                    ) : (
                      part
                    )
                  )}
              </p>

              <p>{retouching[index].para2}</p>
              <ul>
                <li>{retouching[index].list1}</li>
                <li>{retouching[index].list2}</li>
                <li>{retouching[index].list3}</li>
                <li>{retouching[index].list4}</li>
                <li>{retouching[index].list5}</li>
                <li>{retouching[index].list6}</li>
              </ul>
              <p>{retouching[index].para3}</p>
            </div>
            <div className="col-md-6">
              <CompareSlider
                firstImage={imagePairs[index].firstImage}
                secondImage={imagePairs[index].secondImage}
                initialSliderPercentage={50}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-center mb-5">
        <Link to={"/retouching-order"} className="btn bg_maincolor text-white ">
          Order Now
        </Link>
      </div>
    </>
  );
};

export default LandingPage;
